import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { Url } from '../../util/Url';

import AuthPage from './AuthPage';
import PasswordResetForm from './PasswordResetForm';

import Modal from '../../_components/FormComponents/Modal';

interface ICredentials {
    password: string,
    password2: string
}

interface IServerErrorWarning {
    friendlyMessage: string,
    message: string
}

interface IState {
    credentials: ICredentials;
    checkInputIsValid: boolean;
    serverErrorWarning?: IServerErrorWarning;
    showSuccessModal: boolean;
    isResettingPassword: boolean;
}

interface IProps {
    store: ApplicationStore;
}


@inject('store')
@observer
export class PasswordResetPage extends React.Component<IProps & RouteComponentProps<any>, IState> {

    public state: IState = {
        credentials: {
            password: '',
            password2: ''
        },
        checkInputIsValid: false,
        showSuccessModal: false,
        isResettingPassword: false,
    };


    public handleSubmit = (isValid: boolean) => {
        if (isValid) {
            this.setState({isResettingPassword: true}, async () => {
                const query = Url.parseSearchString(this.props.location.search);

                if (query.email && query.reset_token) {

                    this.props.store.passwordResetStore.setNewPassword(
                        query.email,
                        query.reset_token,
                        this.state.credentials.password,
                    )
                        .then((res) => {
                            this.setState({isResettingPassword: false});
                            this.setState({showSuccessModal: true});
                        })
                        .catch((err) => {
                            this.setState({isResettingPassword: false});
                            let serverErrorWarning = {
                                friendlyMessage: 'That did not work',
                                message: 'unknown-error'
                            };
                            this.setState({serverErrorWarning});
                        });
                } else {
                    let serverErrorWarning = {
                        friendlyMessage: 'The URL is missing required parameters',
                        message: 'missing-url-parameters'
                    };
                    this.setState({serverErrorWarning});
                    console.error('email or reset_token undefined in query string:', query);
                }

            });
        }
    }

    public finish = () => {
        this.setState({showSuccessModal: false});
    }

    private setCredentials = (credentials: ICredentials) => {
        this.setState({credentials});
    }

    public render() {

        return (
            <AuthPage>
                <h1 className="auth-page__card__header">Reset Password</h1>
                <PasswordResetForm
                    credentials={this.state.credentials}
                    error={this.state.serverErrorWarning}
                    handleSubmit={this.handleSubmit}
                    isResettingPassword={this.state.isResettingPassword}
                    setCredentials={this.setCredentials}
                />
                <Modal confirmButtonOnClick={this.finish}
                       confirmButtonText="OK"
                       declineButtonOnClick={this.finish}
                       show={this.state.showSuccessModal}
                       title="Success!">
                    Your password has been reset. Please log in.
                </Modal>
            </AuthPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/PasswordResetPage.tsx